import * as helpers from "../Helpers/helpers";
import * as Currency from "../Helpers/Currency";
import { wishlistStore } from "../WishlistStore";
import * as screenSize from "../screenSize";

export const alpineGlobalComponent = () => ({
    ...helpers,
    ...Currency,
    ...wishlistStore,
    ...screenSize,
    ...{
        desktop: false,
    },
});
